import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

// MUI
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

// MUI Icons
import InfoIcon from '@mui/icons-material/Info';
import { SxProps } from '@mui/material';
import { Theme } from '@emotion/react';

type InfoBoxProps = {
  labelToken: string
  sx?: SxProps<Theme>
}
const InfoBox: FC<InfoBoxProps> = (props) => {
  const { labelToken, sx } = props;
  const { t } = useTranslation();

  return (
    <Box display="flex" alignItems="center" gap={1} sx={sx}>
      <InfoIcon sx={{ fontSize: 32 }} color="primary" />
      <Typography variant="body1">{t(labelToken)}</Typography>
    </Box>
  );
}

export default InfoBox;